import styled from "styled-components";
import AnimatedPathName from "../componentes/AnimatedPathName";


const HomeTitle = () => {
  return (
    <SvgWrapper>
      <AnimatedPathName />
    </SvgWrapper>
  );
};

export default HomeTitle;



const SvgWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100vw;
  max-width: 100%;

  svg {
    width: 100%;
    height: auto;
    max-height: 100%;
    display: block;
  }

  @media (max-width: 768px) {
    padding: 1.5rem 0.5rem;
  }

  @media (max-width: 480px) {
    padding: 1rem 0.25rem;
  }
`;